import React, {useState} from "react";
import { Box, Typography } from "@mui/material";
import Button from "./elements/Button";
import { Link } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import axios from "axios";





export const SignupForm = () => {
   const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [flashMessage, setFlashMessage] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        username: "",
        password: "",
        confirmPassword: ""
    });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
         if (formData.password !== formData.confirmPassword) {
            throw new Error("Both Passwords must match!");
         }
   
         const response = await axios.post(
            "https://triphub-backend.onrender.com/api/v1/users/signup",
            formData,
            {
               headers: { "Content-Type": "application/json" }
            }
         );
   
         console.log(response.data);
   
         setFlashMessage({
            type: "success",
            message: "Registration successful. Redirecting to Login.",
         });
   
         setFormSubmitted(true);
   
         setTimeout(() => {
            window.location.href = "/login";
         }, 2000);
      } catch (error) {
         console.error("Error:", error);
   
         let errorMessage;
         if (error.response) {
            console.log("Response Data:", error.response.data);
            errorMessage = error.response.data.detail || error.response.data.message;
         } else {
            console.error("Request Error:", error.request);
            errorMessage = "An error occurred while processing your request."; // Provide a fallback error message
         }
   
         setFlashMessage({ type: "error", message: errorMessage });
      }
   };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword)
    }

    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    return (
        <Box>
            <section className="mt-8">
               <Box className="container mt-10">
                  <Box className="flex flex-wrap -mx-4">
                     <Box className="w-full px-4">
                        <Box className="max-w-[525px] bg-transparent mx-auto text-center rounded-lg relative overflow-hidden
                           py-8
                           px-10
                           sm:px-12
                           md:px-[60px]
                           "
                           >
                           <Box className="mb-5 md:mb-8 text-center">
                              <img 
                                 src={require("../assets/images/logo.png")} 
                                 alt="TripHub Logo"
                                 className="w-55 h-20 mx-auto"
                              />
                           </Box>
                           <form onSubmit={handleSubmit}>
                              {flashMessage && (
                                 <div className={`text-center my-3 ${flashMessage.type === 'success' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
                                    {flashMessage.message}
                                 </div>
                              )}

                                <Box className="mt-4 mb-4">
                                 <input
                                    name="email"
                                    type="email"
                                    placeholder="Enter email"
                                    className="
                                    w-full
                                    rounded-md
                                    border
                                    border-[#E9EDF4]
                                    py-3
                                    px-5
                                    bg-[#FCFDFE]
                                    text-black
                                    placeholder-[#ACB6BE]
                                    outline-none
                                    focus-visible:shadow-none
                                    focus:border-pry
                                    "
                                    onChange={e => 
                                       setFormData({
                                          ...formData, email: e.target.value
                                          })} 
                                    value={formData.email}
                                 />
                              </Box>
                              <Box className="mt-4 mb-4">
                                 <input
                                    name="username"
                                    type="text"
                                    placeholder="Create username"
                                    className="
                                    w-full
                                    rounded-md
                                    border
                                    border-[#E9EDF4]
                                    py-3
                                    px-5
                                    bg-[#FCFDFE]
                                    text-black
                                    placeholder-[#ACB6BE]
                                    outline-none
                                    focus-visible:shadow-none
                                    focus:border-pry
                                    "
                                    onChange={e => 
                                       setFormData({
                                          ...formData, username: e.target.value
                                          })} 
                                    value={formData.username}
                                 />
                              </Box>
                              <Box className="mb-3">
                                 <input
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Create password"
                                    className="
                                    w-full
                                    rounded-md
                                    border
                                    border-[#E9EDF4]
                                    py-3
                                    px-5
                                    bg-[#FCFDFE]
                                    text-black
                                    placeholder-[#ACB6BE]
                                    outline-none
                                    focus-visible:shadow-none
                                    focus:border-pry"
                                    onChange={e => 
                                       setFormData({
                                          ...formData, password: e.target.value
                                          })} 
                                    value={formData.password} />
                                 <button
                                 type="button"
                                 className="absolute inset-y-0 right-0 pr-16 pb-3  flex items-center"
                                 onClick={toggleShowPassword}
                              >
                                 {showPassword ? 
                                    <VisibilityOffIcon /> : <VisibilityIcon />}
                              </button>
                              </Box>
                              <Box className="mb-3 relative">
                                 <input
                                    name="confirmPassword"
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm password"
                                    className="
                                       w-full
                                       rounded-md
                                       border
                                       border-[#E9EDF4]
                                       py-3
                                       px-5
                                       bg-[#FCFDFE]
                                       text-black
                                       placeholder-[#ACB6BE]
                                       outline-none
                                       focus-visible:shadow-none
                                       focus:border-pry"
                                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                                    value={formData.confirmPassword}
                                 />
                                 <button
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-1 pt-2 flex items-center"
                                    onClick={toggleShowConfirmPassword}
                                 >
                                    {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                 </button>
                                 </Box>

                              <Box className="mt-[-6%] mb-5">
                                 <Button 
                                    type="submit"
                                    size="large" 
                                    className="px-12"
                                 >
                                    Create Account
                                 </Button>
                                    <Typography 
                                       variant="h6" 
                                       paragraph
                                       sx={{
                                          fontWeight: "400",
                                          textAlign: "center",
                                          marginTop: "10px",
                                          marginBottom: "50px",
                                          fontSize: "14px"
                                       }}
                                       className="text-gray-500"
                                    >
                                       Cancel
                                    </Typography>
                              </Box>
                           </form>
                           <Box
                              sx={{
                                 display: "flex",
                                 justifyContent: "space-between",
                                 alignItems: "center"
                              }}
                              >
                              <Typography
                                 variant="h6"
                                 paragraph
                                 sx={{
                                    fontSize: "14px",
                                    fontWeight: "300"
                                 }}
                                 className="text-faded"
                              >
                                 Already a member?
                              </Typography>

                              <Link to="/login" sx={{ display: 'flex', alignItems: 'center' }}>
                                 <Typography
                                    variant="h6"
                                    sx={{
                                    fontSize: "14px",
                                    textAlign: "right"
                                    }}
                                    className="text-pry inline"
                                 >
                                    Login
                                 </Typography>
                                 <span className="inline text-pry">
                                    <ArrowForwardIcon sx={{ color: "#7159EA", ml: 1 }} />
                                 </span>
                              </Link>
                              </Box>

                        </Box>
                     </Box>
                  </Box>
               </Box>
            </section>
         </Box>
    );
};